<mat-icon [class.new-product]="isNewProduct"
          [class.discontinued]="isDiscontinuedProduct"
          [class.price-change]="hasPriceChange"
          [class.focus]="hasFocus"
          [matTooltip]="tooltip">
    {{icon}}
</mat-icon>
